import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import Support from "@/components/landing/Support";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-cream text-navy">
            <Nav />
            <Hero />
            <Marquee />
            <Chapters />
            <Support />
            <Faq />
            <Footer />
        </main>
    );
}
